"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.sort");
var _bookMaterialsDetailCpt = _interopRequireDefault(require("./bookMaterialsDetailCpt"));
var _booking = require("@/api/bookSpace/booking");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "bookMaterialsDetailVerify",
  components: {
    bookMaterialsDetail: _bookMaterialsDetailCpt.default
  },
  data: function data() {
    return {
      bookingId: "",
      ebVerBookingHeadCom: {},
      webBookingHeadCom: {},
      differentKeys: [],
      consignerCheck: [],
      consigneeCheck: [],
      notifierOneCheck: [],
      notifierTwoCheck: [],
      bkCargoDiff: [],
      bkPreContainerDiff: [],
      bkContainerDiff: [],
      feeItemDiff: [],
      bkYardDiff: [],
      bkDocumentDiff: [],
      loading: null,
      isShow: false
    };
  },
  mounted: function mounted() {
    this.bookingId = this.$route.query.id;
    this.handleSelect(this.bookingId);
  },
  methods: {
    // 处理收法通信息
    handleInfoShou: function handleInfoShou(data) {
      // 数组 a
      var a = [0, 1, 2, 3];
      // 遍历数组 a
      a.forEach(function (type) {
        // 查找是否存在对应的 customerType
        var exists = data.some(function (item) {
          return item.customerType === type;
        });
        // 如果不存在，添加新的对象
        if (!exists) {
          data.push({
            companyName: null,
            customerName: null,
            customerCode: null,
            customerType: type,
            webBkCusCatalogComs: []
          });
        }
      });
      // 按 customerType 排序
      return data.sort(function (a, b) {
        return a.customerType - b.customerType;
      });
    },
    generateAndSortArray: function generateAndSortArray(webBkCusCatalogComs, sequence) {
      var result = [];
      sequence.forEach(function (seq) {
        var found = webBkCusCatalogComs.find(function (item) {
          return item.sequence === seq;
        });
        if (found) {
          result.push(found);
        } else {
          var newObj = {
            catalogContent: '',
            bkCusCatalogWebComId: null,
            bkCustomerWebComId: null,
            sequence: seq,
            printOrder: seq
          }; // Default values assumed based on the example
          result.push(newObj);
        }
      });
      return result;
    },
    // 处理收法通的信息
    handleSetMessage: function handleSetMessage(data) {
      var _this = this;
      var newData = this.handleInfoShou(data);
      var sequence = ['1', '2', '7', '8', '10', '9', '15', '16', '11', '12', '13', '14'];
      newData.forEach(function (item) {
        item.webBkCusCatalogComs = _this.generateAndSortArray(item.webBkCusCatalogComs, sequence);
      });
      return newData;
    },
    handleSelect: function handleSelect(bookingId) {
      var _this2 = this;
      this.loading = (0, _utils.load)();
      (0, _booking.queryEbVerBookingHeadComById)(bookingId).then(function (res) {
        if (res.success) {
          _this2.ebVerBookingHeadCom = res.data.ebVerBookingHeadCom;
          _this2.webBookingHeadCom = res.data.webBookingHeadCom;
          _this2.ebVerBookingHeadCom.webBkCustomerComs = _this2.handleSetMessage(_this2.ebVerBookingHeadCom.webBkCustomerComs);
          _this2.webBookingHeadCom.webBkCustomerComs = _this2.handleSetMessage(_this2.webBookingHeadCom.webBkCustomerComs);

          // 处理订舱人表结构的问题
          var webBkExtendComs = _this2.webBookingHeadCom.webBkExtendComs;
          if (webBkExtendComs && webBkExtendComs.length > 0) {
            _this2.$set(_this2.webBookingHeadCom, 'bookingFwdPerson', webBkExtendComs[0].bookingFwdPerson);
            _this2.$set(_this2.webBookingHeadCom, 'bookingFwdTel', webBkExtendComs[0].bookingFwdTel);
            _this2.$set(_this2.webBookingHeadCom, 'bookingFwdEmail', webBkExtendComs[0].bookingFwdEmail);
          }
          var ebWebBkExtendComs = _this2.ebVerBookingHeadCom.webBkExtendComs;
          if (ebWebBkExtendComs && ebWebBkExtendComs.length > 0) {
            _this2.$set(_this2.ebVerBookingHeadCom, 'bookingFwdPerson', ebWebBkExtendComs[0].bookingFwdPerson);
            _this2.$set(_this2.ebVerBookingHeadCom, 'bookingFwdTel', ebWebBkExtendComs[0].bookingFwdTel);
            _this2.$set(_this2.ebVerBookingHeadCom, 'bookingFwdEmail', ebWebBkExtendComs[0].bookingFwdEmail);
          }
          //匹配头部信息
          _this2.differentKeys = _this2.objectCompare(_this2.ebVerBookingHeadCom, _this2.webBookingHeadCom);
          //附加费与杂费
          _this2.feeItemDiff = _this2.newAndOldCompare(_this2.ebVerBookingHeadCom.webFeeItemComs, _this2.webBookingHeadCom.webFeeItemComs);
          //场站信息
          _this2.bkYardDiff = _this2.newAndOldCompare(_this2.ebVerBookingHeadCom.webBkYardComs, _this2.webBookingHeadCom.webBkYardComs);
          // BK Document
          _this2.bkDocumentDiff = _this2.newAndOldCompare(_this2.ebVerBookingHeadCom.webBkDocumentComs, _this2.webBookingHeadCom.webBkDocumentComs);
          //匹配箱信息
          _this2.bkContainerDiff = _this2.newAndOldCompare(_this2.ebVerBookingHeadCom.webBkContainerComs, _this2.webBookingHeadCom.webBkContainerComs);
          //匹配下货纸
          _this2.bkPreContainerDiff = _this2.newAndOldCompare(_this2.ebVerBookingHeadCom.webBkPreContainerComs, _this2.webBookingHeadCom.webBkPreContainerComs);
          //匹配货物信息
          _this2.bkCargoDiff = _this2.objectCompare(_this2.ebVerBookingHeadCom.webBkCargoComs[0], _this2.webBookingHeadCom.webBkCargoComs[0]);
          //匹配收发通
          var consigner = _this2.ebVerBookingHeadCom.webBkCustomerComs[0];
          var consignee = _this2.ebVerBookingHeadCom.webBkCustomerComs[1];
          var notifierOne = _this2.ebVerBookingHeadCom.webBkCustomerComs[2];
          var notifierTwo = _this2.ebVerBookingHeadCom.webBkCustomerComs[3];
          var consignerNew = _this2.webBookingHeadCom.webBkCustomerComs[0];
          var consigneeNew = _this2.webBookingHeadCom.webBkCustomerComs[1];
          var notifierOneNew = _this2.webBookingHeadCom.webBkCustomerComs[2];
          var notifierTwoNew = _this2.webBookingHeadCom.webBkCustomerComs[3];
          _this2.sortWebBkCusCatalogCom(consigner.webBkCusCatalogComs);
          _this2.sortWebBkCusCatalogCom(consignerNew.webBkCusCatalogComs);
          _this2.sortWebBkCusCatalogCom(consignee.webBkCusCatalogComs);
          _this2.sortWebBkCusCatalogCom(consigneeNew.webBkCusCatalogComs);
          _this2.sortWebBkCusCatalogCom(notifierOne.webBkCusCatalogComs);
          _this2.sortWebBkCusCatalogCom(notifierOneNew.webBkCusCatalogComs);
          _this2.sortWebBkCusCatalogCom(notifierTwo.webBkCusCatalogComs);
          _this2.sortWebBkCusCatalogCom(notifierTwoNew.webBkCusCatalogComs);
          _this2.consignerCheck = _this2.newAndOldCompareCustomer(consigner.webBkCusCatalogComs, consignerNew.webBkCusCatalogComs);
          _this2.consigneeCheck = _this2.newAndOldCompareCustomer(consignee.webBkCusCatalogComs, consigneeNew.webBkCusCatalogComs);
          _this2.notifierOneCheck = _this2.newAndOldCompareCustomer(notifierOne.webBkCusCatalogComs, notifierOneNew.webBkCusCatalogComs);
          _this2.notifierTwoCheck = _this2.newAndOldCompareCustomer(notifierTwo.webBkCusCatalogComs, notifierTwoNew.webBkCusCatalogComs);
        }
      }).finally(function () {
        _this2.isShow = true;
        _this2.loading.close();
      });
    },
    sortWebBkCusCatalogCom: function sortWebBkCusCatalogCom(webBkCusCatalogComs) {
      if (!webBkCusCatalogComs || webBkCusCatalogComs.length === 0) {
        return;
      }
      webBkCusCatalogComs.sort(function (a, b) {
        return a.sequence - b.sequence;
      });
    },
    //比较两个对象字段值
    objectCompare: function objectCompare(object1, object2) {
      return Object.keys(object1).filter(function (key) {
        return object1[key] !== object2[key];
      });
    },
    newAndOldCompare: function newAndOldCompare(newValue, oldValue) {
      var resultMap = [];
      if (newValue.length >= oldValue.length) {
        resultMap = this.collectionCompare(newValue, oldValue);
      } else {
        resultMap = this.collectionCompare(oldValue, newValue);
      }
      return resultMap;
    },
    newAndOldCompareCustomer: function newAndOldCompareCustomer(newValue, oldValue) {
      var resultMap = [];
      if (newValue.length >= oldValue.length) {
        resultMap = this.collectionCompareCustomer(newValue, oldValue);
      } else {
        resultMap = this.collectionCompareCustomer(oldValue, newValue);
      }
      return resultMap;
    },
    collectionCompareCustomer: function collectionCompareCustomer(array1, array2) {
      var resultMap = [];
      array1.forEach(function (itemB, index) {
        var itemA = array2[index];
        var sequence = itemB.sequence;
        if (!itemA) {
          for (var key in itemB) {
            resultMap.push("".concat(key).concat(sequence));
          }
        } else {
          for (var _key in itemA) {
            if (itemB && itemA[_key] != itemB[_key]) {
              resultMap.push("".concat(_key).concat(sequence));
            }
          }
        }
      });
      return resultMap;
    },
    collectionCompare: function collectionCompare(array1, array2) {
      var resultMap = [];
      array1.forEach(function (itemB, index) {
        var itemA = array2[index];
        if (!itemA) {
          for (var key in itemB) {
            resultMap.push("".concat(key).concat(index));
          }
        } else {
          for (var _key2 in itemA) {
            if (itemB && itemA[_key2] != itemB[_key2]) {
              resultMap.push("".concat(_key2).concat(index));
            }
          }
        }
      });
      return resultMap;
    }
  }
};